/**
 * Single source of truth for the AI tool stack.
 * Consumed by: /hire (WhatIBuildWithAI), /ai-teams (AISystemsSection + AIStackPills), /1-1 (Advisory).
 * Any change here propagates to all three pages via i18n and direct imports.
 */

export const primaryStack = [
  "Claude CoWork / Code",
  "ChatGPT",
  "Codex",
  "Antigravity",
  "Gemini",
] as const;

export const secondaryStack = [
  "Perplexity",
  "NotebookLM",
  "OpenClaw (Self-Hosted)",
  "Obsidian",
  "Wispr Flow",
  "Lovable",
  "Google Stitch",
] as const;

export const fullStack: readonly string[] = [...primaryStack, ...secondaryStack];
